import { Alert, ErrorExclamation } from "@suralink/samurai/icons";
import React from "react";
import { connect } from "react-redux";
import styles from "../../styles/VerifyPassword.module.scss";

interface StateProps {
  createAccountInfo: any;
}

interface DispatchProps {}

interface ComponentProps {
  style?: any;
}

type Props = StateProps & DispatchProps & ComponentProps;

const VerifyPassword: React.FC<Props> = ({ createAccountInfo, style }) => {
  const lengthCheck =
    createAccountInfo.password && createAccountInfo.password.length >= 8;
  const caseCheck =
    createAccountInfo.password &&
    !!createAccountInfo.password.match(/[A-Z]/) &&
    !!createAccountInfo.password.match(/[a-z]/);
  const alphaNumCheck =
    createAccountInfo.password &&
    !!createAccountInfo.password.match(/[0-9]/) &&
    !!createAccountInfo.password.match(/[a-z]/i);
  const specialCharCheck =
    createAccountInfo.password && !!createAccountInfo.password.match(/\W|_/);
  const matchCheck =
    createAccountInfo.password === createAccountInfo.passwordConfirmation &&
    createAccountInfo.password !== "" &&
    createAccountInfo.passwordConfirmation !== "";

  return (
    <div className={styles.verifyMain} style={{ ...style }}>
      <div className={styles.verifyMessage}>
        <h3>Password requirements</h3>
      </div>
      <div className={styles.verificationCriteria}>
        <div className={styles.criteria}>
          <span className={styles.criteriaIcon}>
            {lengthCheck ? <Alert /> : <ErrorExclamation />}
          </span>
          <span
            className={styles.criteriaText}
            style={{
              fontWeight: lengthCheck ? 500 : 600,
            }}
          >
            At least 8 characters
          </span>
        </div>
        <div className={styles.criteria}>
          <span className={styles.criteriaIcon}>
            {caseCheck ? <Alert /> : <ErrorExclamation />}
          </span>
          <span
            className={styles.criteriaText}
            style={{
              fontWeight: caseCheck ? 500 : 600,
            }}
          >
            Both upper and lower case letters
          </span>
        </div>
        <div className={styles.criteria}>
          <span className={styles.criteriaIcon}>
            {alphaNumCheck ? <Alert /> : <ErrorExclamation />}
          </span>
          <span
            className={styles.criteriaText}
            style={{
              fontWeight: alphaNumCheck ? 500 : 600,
            }}
          >
            A mixture of letters and numbers
          </span>
        </div>
        <div className={styles.criteria}>
          <span className={styles.criteriaIcon}>
            {specialCharCheck ? <Alert /> : <ErrorExclamation />}
          </span>
          <span
            className={styles.criteriaText}
            style={{
              fontWeight: specialCharCheck ? 500 : 600,
            }}
          >
            At least one special character{" "}
          </span>
        </div>
        <div className={styles.criteria}>
          <span className={styles.criteriaIcon}>
            {matchCheck ? <Alert /> : <ErrorExclamation />}
          </span>
          <span
            className={styles.criteriaText}
            style={{
              fontWeight: matchCheck ? 500 : 600,
            }}
          >
            Verify & new password must match
          </span>
        </div>
      </div>
    </div>
  );
};

const mstp = (state: InitialStateModel): StateProps => {
  const { createAccountInfo } = state;
  return {
    createAccountInfo,
  };
};

const matp = ((): DispatchProps => {
  return {};
})();

export default connect(mstp, matp)(VerifyPassword);
